import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

// helpers
import get from 'lodash.get';

// styles
import styles from './SbRespBrowseHeader.scss';

// constants
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
const { BROWSE } = pageTypes;

const SbRespBrowseHeaderComponent = ({ itemSearch }) => {
    const header = get(itemSearch, 'meta.header');
    const pageType = get(itemSearch, 'pageType');

    if (pageType !== BROWSE || !header) {
        return null;
    }
    return (
        <span className={styles.header}>
            <FormattedMessage
                id="sb.SbRespBrowseHeader.header"
                defaultMessage="Browse All in {header}"
                values={{ header }}
            />
        </span>
    );
};

SbRespBrowseHeaderComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
};

export const SbRespBrowseHeader = createFragmentContainer(SbRespBrowseHeaderComponent, {
    itemSearch: graphql`
        fragment SbRespBrowseHeader_itemSearch on ItemSearchQueryConnection {
            pageType
            meta {
                header
            }
        }
    `,
});
